import { ChangeEvent, MouseEvent, RefObject } from 'react'

import { KTIcon } from '../../../../../_metronic/helpers'
import { RECEIPT_ACCEPT } from './useReceiptActions'

interface Props {
  inputRef: RefObject<HTMLInputElement>
  isBusy: boolean
  onClick: (e: MouseEvent<HTMLButtonElement>) => void
  onFileSelect: (e: ChangeEvent<HTMLInputElement>) => void
}

/**
 * Кнопка «Заменить чек» рядом с текущим чеком пополнения. Прежний файл остаётся в истории.
 */
export const ReceiptReplaceButton = ({ inputRef, isBusy, onClick, onFileSelect }: Props) => (
  <div className='flex flex-column'>
    <input
      ref={inputRef}
      type='file'
      accept={RECEIPT_ACCEPT}
      onChange={onFileSelect}
      data-testid='receipt-replace-input'
      style={{ visibility: 'hidden', width: 0, height: 0 }}
      disabled={isBusy}
    />
    <button
      type='button'
      className={`btn ${!isBusy ? `btn-icon` : ``} btn-bg-light btn-active-color-primary btn-sm`}
      title='Заменить чек'
      disabled={isBusy}
      onClick={onClick}
    >
      {!isBusy ? (
        <KTIcon className='fs-2' iconName='arrows-loop' />
      ) : (
        <span className='d-flex' style={{ alignItems: 'center' }}>
          <span className='spinner-border spinner-border-sm align-middle me-2'></span>
          Замена...
        </span>
      )}
    </button>
  </div>
)
